<div class="strasse-hausnummer">
  <mat-form-field class="strasse" [subscriptSizing]="subscriptSizing()">
    <mat-label>Straße</mat-label>
    <input type="text" [formField]="field()" matInput [matAutocomplete]="auto" autocomplete="off" />
    @for (fehler of field()().errors(); track $index) {
      <mat-error>{{ fehler.message }}</mat-error>
    }

    <mat-autocomplete #auto="matAutocomplete">
      @if (suggestions.isLoading()) {
        <mat-option disabled>Lädt Vorschläge...</mat-option>
      } @else if (suggestions.error()) {
        <mat-option disabled>Fehler beim Laden</mat-option>
      } @else {
        @for (suggestion of suggestions.value(); track $index) {
          <mat-option [value]="suggestion.street ?? ''" (onSelectionChange)="applyAutocompleteSelection(suggestion)">
            {{ label(suggestion) }}
          </mat-option>
        } @empty {
          @if (field()().value()) {
            <mat-option disabled>Keine Vorschläge gefunden</mat-option>
          }
        }
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="hausnummer" [subscriptSizing]="subscriptSizing()">
    <mat-label>Hausnr.</mat-label>
    <input type="text" [formField]="houseNumberField()" matInput autocomplete="off" />
    @for (fehler of houseNumberField()().errors(); track $index) {
      <mat-error>{{ fehler.message }}</mat-error>
    }
  </mat-form-field>
</div>
